'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import Button, { ButtonSize } from '../../Button/Button';
import OffcanvasCloseButton from '../OffcanvasCloseButton/OffcanvasCloseButton';
import OffcanvasBreadcrumbs from '../OffcanvasBreadcrumbs/OffcanvasBreadcrumbs';
import { NavigationNode } from '@/src/lib/navigation/type';
import { Dictionary } from '@/src/lib/dictionary/types';
import { usePathname } from 'next/navigation';
import { isActiveNavigationNode } from '@/src/lib/navigation/utils';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';
export type OffcanvasNavigationLayerProps = {
  navigationLayer: NavigationNode;
  dict: Dictionary;
  onBacklinkClick: (event: React.SyntheticEvent, node: NavigationNode) => void;
  onNodeClick: (event: React.SyntheticEvent, node: NavigationNode) => void;
  activeNodes: Array<NavigationNode>;
  onCloseClick: () => void;
  languageDropdown?: React.JSX.Element;
};
export default function OffcanvasNavigationLayer(t0) {
  const $ = _c(42);
  const {
    navigationLayer,
    dict,
    onBacklinkClick,
    onNodeClick,
    activeNodes,
    onCloseClick,
    languageDropdown
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== onCloseClick) {
    t1 = <OffcanvasCloseButton onCloseClick={onCloseClick} />;
    $[0] = onCloseClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeNodes || $[3] !== dict || $[4] !== onBacklinkClick) {
    t2 = activeNodes.length ? <OffcanvasBreadcrumbs dict={dict} nodes={activeNodes} onClick={onBacklinkClick} /> : null;
    $[2] = activeNodes;
    $[3] = dict;
    $[4] = onBacklinkClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== navigationLayer || $[7] !== onBacklinkClick) {
    t3 = e => onBacklinkClick(e, navigationLayer);
    $[6] = navigationLayer;
    $[7] = onBacklinkClick;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Icon name={IconName.ARROW_BACK} className={classNames("absolute right-full -top-px pr-4 md:pr-6 text-4xl! group-hover:pr-6 md:group-hover:pr-8", "transition-all ease-in-out duration-150 motion-reduce:transition-none motion-reduce:hover:transform-none")} />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== navigationLayer.title) {
    t5 = <h3 className="display-title-3xl group-hover:text-white">{navigationLayer.title}</h3>;
    $[10] = navigationLayer.title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <div className="py-3"><button className="group text-left uppercase relative" onClick={t3}>{t4}{t5}</button></div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== activeNodes || $[16] !== dict || $[17] !== languageDropdown || $[18] !== navigationLayer.children || $[19] !== onBacklinkClick || $[20] !== onCloseClick || $[21] !== onNodeClick || $[22] !== pathname) {
    t7 = navigationLayer.children?.map(child => <li key={child.resourceId ?? child.url} className="py-0.5"><Link href={child.url || ""} className={classNames("no-underline! inline-block py-1.5 hover:!underline", {
        "font-bold": child.children?.length,
        "px-2 -ml-2 bg-primary-700 hover:!no-underline": isActiveNavigationNode(child, pathname)
      })} onClick={e_0 => onNodeClick(e_0, child)}>{child.title}</Link>{child.children?.length && activeNodes.includes(child) ? <OffcanvasNavigationLayer dict={dict} navigationLayer={child} onBacklinkClick={onBacklinkClick} onNodeClick={onNodeClick} activeNodes={activeNodes} onCloseClick={onCloseClick} languageDropdown={languageDropdown} /> : null}</li>);
    $[15] = activeNodes;
    $[16] = dict;
    $[17] = languageDropdown;
    $[18] = navigationLayer.children;
    $[19] = onBacklinkClick;
    $[20] = onCloseClick;
    $[21] = onNodeClick;
    $[22] = pathname;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t7) {
    t8 = <ul className="mt-2!">{t7}</ul>;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const t9 = navigationLayer.url || "";
  let t10;
  if ($[26] !== dict.general.explore || $[27] !== navigationLayer.title) {
    t10 = dict.general.explore.replace("%s", navigationLayer.title);
    $[26] = dict.general.explore;
    $[27] = navigationLayer.title;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== onCloseClick || $[30] !== t10 || $[31] !== t9) {
    t11 = <Button icon={IconName.TRAVEL_EXPLORE} priority={true} className="mt-8! box-border max-w-full" textClassName="whitespace-nowrap overflow-hidden text-ellipsis" size={ButtonSize.LARGE} href={t9} onClick={onCloseClick}>{t10}</Button>;
    $[29] = onCloseClick;
    $[30] = t10;
    $[31] = t9;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t11 || $[34] !== t2 || $[35] !== t6 || $[36] !== t8) {
    t12 = <div className="flex-grow space-y-6 flex flex-col py-6 pr-8 w-full sm:max-w-[500px] pl-16 md:pl-20">{t2}{t6}{t8}{t11}</div>;
    $[33] = t11;
    $[34] = t2;
    $[35] = t6;
    $[36] = t8;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  const t13 = languageDropdown ? languageDropdown : null;
  let t14;
  if ($[38] !== t1 || $[39] !== t12 || $[40] !== t13) {
    t14 = <><div className="h-dvh absolute inset-0 bg-primary z-20" data-testid="offcanvas-layer"><div className="h-full flex flex-col items-end overflow-auto">{t1}{t12}{t13}</div></div></>;
    $[38] = t1;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
}